import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from "@angular/core";
@Component({
  selector: "app-person-edit-form-default",
  templateUrl: "./edit-form-default.component.html",
  styleUrls: ["./edit-form-default.component.css"],
})
export class PersonEditFormDefaultComponent {
  @Input() editItem: any;
  @Input() search: any;
  @Input() edit: any;
  @Input() language_list: any;
  @Input() commonService: any;
  @Input() usersService: any;
  @Input() ROLE: any;
  @Input() selected_event_id: any;

  @Output() onSave = new EventEmitter<void>();
  @Output() onCancel = new EventEmitter<void>();
  @Output() onDelete = new EventEmitter<void>();
  @Output() onCalcAge = new EventEmitter<void>();
  @Output() onPwReset = new EventEmitter<void>();
  @Output() onGoPerson = new EventEmitter<number>();
  @Output() onSaikenFilesSelected = new EventEmitter<any>();
  @Output() onOpenPreview = new EventEmitter<any>();
  @Output() onRemoveSaikenFile = new EventEmitter<number>();
  @Output() onChangeSelectCompany = new EventEmitter<void>();

  public isCollapsed = {
    basic: false,
    affiliation: true,
    account: true,
    upload: true,
  };

  public affiliationFields = [
    {
      label: "会社",
      name: "company",
      model: "t_company_id",
      req: true,
      isCompany: true,
    },
    {
      label: "事業場",
      name: "jigyoba",
      model: "t_jigyoba_id",
      req: true,
      listKey: "jigyoba_list",
    },
    {
      label: "職場",
      name: "syokuba",
      model: "t_syokuba_id",
      req: true,
      listKey: "syokuba_list",
    },
    {
      label: "所属",
      name: "syozoku",
      model: "t_syozoku_id",
      req: true,
      listKey: "syozoku_list",
    },
    {
      label: "事業所",
      name: "jigyosyo",
      model: "t_jigyosyo_id",
      req: true,
      listKey: "jigyosyo_list",
    },
    {
      label: "役職",
      name: "yakusyoku",
      model: "t_yakusyoku_id",
      req: true,
      listKey: "yakusyoku_list",
    },
    {
      label: "資格",
      name: "shikaku",
      model: "t_shikaku_id",
      req: true,
      listKey: "shikaku_list",
    },
    {
      label: "職種",
      name: "syokusyu",
      model: "t_syokusyu_id",
      req: true,
      listKey: "syokusyu_list",
    },
    {
      label: "身分",
      name: "mibun",
      model: "t_mibun_id",
      req: true,
      listKey: "mibun_list",
    },
    {
      label: "コース",
      name: "course",
      model: "t_course_id",
      req: true,
      listKey: "course_list",
    },
  ];

  toggleCollapse(section: string) {
    this.isCollapsed[section] = !this.isCollapsed[section];
  }

  // エラー回避用：クラス名を文字列で返す
  getCollapseClass(section: string) {
    return this.isCollapsed[section] ? "collapse" : "collapse show";
  }

  fileSelected(event: any, index: number) {
    this.onSaikenFilesSelected.emit({ event, index });
  }
}



// WEBPACK FOOTER //
// ./src/app/a0108-person/edit-form/default/edit-form-default.component.ts